module.exports = __webpack_public_path__ + "static/media/fuwuchengnuo.87c04e0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/detail/images/fuwuchengnuo.png
// module id = 746
// module chunks = 0